import React from "react";
import {
  DefaultButton,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { Formik } from "formik";
import {
  addTempAndRhRemarks,
  updateTempAndRhRemarks,
} from "../../../services/customers/CustomerService";
import {
  ITempAndRhPageWiseRemarks,
} from "../../../vm";
import { childrenGap } from "../../common/Constants";
import CustomDrawer from "../../common/CustomDrawer";
import { CustomTextField } from "../../common/Library";
import { ToastContext } from "../../common/ToastProvider";
import * as yup from "yup";

const tempRhRemarksSchema = yup.object().shape({
  remarks: yup.string().required().max(190, "Remarks should be less than 190 characters"),
});

export interface ManageTempRhRemarksDialogProps {
  data?: ITempAndRhPageWiseRemarks;
  handleLoading: any;
  handleDialogClose: any;
  customerId: string;
  date: Date;
  datacenterId: string;
  tempRhPageId: string;
}

const ManageTempRhRemarksDialog: React.FC<ManageTempRhRemarksDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  customerId,
  date,
  datacenterId,
  tempRhPageId
}) => {
  //state
  const [state, setState] = React.useState({
    tempRhRemarks: {
      date: date,
      remarks: "",
      customerId: customerId,
      datacenterId: datacenterId,
      tempRhPageId: tempRhPageId,
      ...data,
    },
    isLoading: false,
  } as {
    tempRhRemarks: ITempAndRhPageWiseRemarks;
    isLoading: boolean;
  });

  console.log("data", data);

  //hooks
  const { showToast } = React.useContext(ToastContext);

  const closeAddDialog = (data?: ITempAndRhPageWiseRemarks) => {
    handleDialogClose(data);
  };


  return (
    <React.Fragment>
      <CustomDrawer
        title={
          state.tempRhRemarks._id
            ? "Update Temp/RH Remarks"
            : "Add Temp/RH Remarks"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            initialValues={state.tempRhRemarks}
            validationSchema={tempRhRemarksSchema}
            onSubmit={async (values: ITempAndRhPageWiseRemarks, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              handleLoading();
              if (state.tempRhRemarks._id) {
                result = await updateTempAndRhRemarks(obj);
              } else {
                result = await addTempAndRhRemarks(obj);
              }
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result?.message ||
                  `Error while ${state.tempRhRemarks._id ? "updating" : "adding"
                  } temp/rh remarks`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              handleSubmit, values
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap} className="">
                  <Stack.Item>
                    <CustomTextField name={"remarks"} label={"Remarks"} multiline description={`No of characters ${values.remarks.length} out of 190`} autoAdjustHeight />
                  </Stack.Item>
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                      className="pt-16"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        type="submit"
                        text={state.tempRhRemarks._id ? "Update" : "Add"}
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageTempRhRemarksDialog;
